module.exports = __webpack_public_path__ + "img/oliver-borner11.4d10a73a.jpg";